/**
 *
 * Asynchronously loads the component for MemberNotes
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
